//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { format, AesDecrypt } from '@/js/utils'
export default {
  name: 'repayRecordList',
  created() {
    this.showTheLoading(async () => {
      let now = new Date()
      const tomorrow = new Date(
        now.setTime(now.getTime() + 24 * 60 * 60 * 1000)
      )
      now = new Date()
      const oneyearago = new Date(
        now.setTime(now.getTime() - 366 * 24 * 60 * 60 * 1000)
      )
      const data = await this.doRequest('queryRecord', {
        orderNum: this.$store.orderNo,
        startTime: format(oneyearago, 'yyyy-MM-dd'),
        endTime: format(tomorrow, 'yyyy-MM-dd')
      })
      this.recordList = data.records
      this.$bus.$emit('update-title', {
        hasHeader: data.sourceTitle
      })
    }, 'isLoading')
  },
  data() {
    return {
      isLoading: false,
      recordList: []
    }
  },
  methods: {
    async rerepay(params) {
      params.tradeId  = AesDecrypt(params.tradeId);
      const data = await this.doRequest(
        'getRetryUrl',
        Object.assign(params, { orderNum: this.$store.orderNo })
      )
      location.href = data.url
    }
  }
}
